var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipLactose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12C1.5 17.8 6.2 22.5 12 22.5C17.8 22.5 22.5 17.8 22.5 12C22.5 6.2 17.8 1.5 12 1.5ZM16.06 18.17C16.06 19.1 15.35 19.85 14.48 19.85H9.52C8.65 19.85 7.94 19.1 7.94 18.17V11.25C7.94 10.52 8.26 9.83 8.8 9.38C9.32 8.94 9.63 7.28 9.63 6.57V4.71C9.63 4.4 9.88 4.14 10.2 4.14H13.8C14.12 4.14 14.38 4.4 14.38 4.72V6.56C14.38 7.27 14.69 8.93 15.21 9.37C15.75 9.82 16.07 10.51 16.07 11.24V18.16L16.06 18.17Z",
    fill: "#00AEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81 10.89C9.33 10.83 8.94 11.17 8.94 11.65V18.17C8.94 18.54 9.2 18.85 9.52 18.85H14.48C14.8 18.85 15.06 18.55 15.06 18.17V11.25C15.06 10.89 14.99 10.6 14.66 10.51C13.94 10.32 13.77 10.83 11.76 11.16C11.3 11.24 10.48 10.96 9.81 10.88V10.89Z",
    fill: "#00AEFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.19 6.81C14.19 6.73 14.18 6.64 14.18 6.58V5.84H9.83V6.59C9.83 6.66 9.83 6.74 9.82 6.82H14.19V6.81Z",
    fill: "#00AEFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipLactose);
export default __webpack_public_path__ + "static/media/ic-chip-lactose.c6c4f3488a4288500a77f0310a299b71.svg";
export { ForwardRef as ReactComponent };